module.exports = {
	"ru": {
		"translation": {
			"moreInformation": "Подробнее",
			"close": "Закрыть",
			"uploader": {
				"overlay": {
					"title": "Перетащите",
					"subtitle": "файлы сюда"
				},
				"form": {
					"dragAndDrop": "Перетащите",
					"or": "или",
					"chooseFiles": "выберите файлы",
					"from": "с компьютера"
				},
				"errors": {
					"file_size": "превышает максимальный {{size}} размер файла.",
					"file_type": "{{type}} недопустимый тип файла."
				},
				"status": {
					"idle": "ожидание",
					"processing": "обработка",
					"uploading": "загрузка",
					"success": "успешно",
					"cancel": "отменить",
					"error": "ошибка",
					"none": ""
				}
			},
			"actions": {
				"delete": "Удалить",
				"apply": "Применить",
				"cancel": "Отмена"
			},
			"dateInput": {
				"choose": "Выбрать дату",
				"clear": "Удалить дату"
			},
			"daterange": {
				"last_7_days": "Последние 7 дней",
				"last_30_days": "Последние 30 дней",
				"this_month": "Этот месяц",
				"last_month": "Прошлый месяц",
				"start_date": "Дата начала",
				"end_date": "Дата завершения",
				"not_set": "Не задано"
			},
			"comment": {
				"delete": "Удалить комментарий"
			},
			"pagination": {
				"intro": "Нумерация страниц, текущая страница {{currentPage}}",
				"page": "Страница {{pageNumber}}",
				"ellipsis": "Больше страниц",
				"prev": "Предыдущая страница",
				"next": "Следующая страница"
			},
			"formElement": {
				"optional": "(опционально)",
				"required": "(обязательно)"
			},
			"prevNextArrowButton": {
				"arrowup": "вверх",
				"arrowdown": "вниз",
				"escape": "выйти"
			},
			"externalLink": {
				"view": "просмотр"
			},
			"collapsible": {
				"ariaText": "свертываемый раздел"
			}
		}
	}
};